import { Input } from '@lt/components';
import { DropdownIconJoint } from '@lt/components/icons-react/userflow';
import { useTranslation } from '@lt/localization';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import OrdersAmountMobile from './components/OrdersAmountMobile';
import OrdersAmountDesktop from './components/OrdersAmountDesktop';
import type { OrderAmountFormProps } from '../../../types';

const OrdersAmountForm = (props: OrderAmountFormProps): JSX.Element => {
  const { isMobile, fieldValue, setFieldValue } = props;
  const { t } = useTranslation();
  const labelText = t('checkout.services.jointOrder.firstOrder.labelText');
  const [isOrdersAmountFieldOpened, setIsOrdersAmountFieldOpened] =
    useState<boolean>(false);
  useEffect(() => {
    setFieldValue(fieldValue || 2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const closeMenu = () => {
    setIsOrdersAmountFieldOpened(false);
  };
  useEffect(() => {
    if (isOrdersAmountFieldOpened && !isMobile)
      document.addEventListener('click', closeMenu, { once: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOrdersAmountFieldOpened]);
  const handleOrderNumberClicked = (orderAmount: number) => {
    setFieldValue(orderAmount);
  };
  return (
    <StyledFormContainer>
      <StyledLabel>{labelText}</StyledLabel>

      <StyledInput
        readOnly
        onClick={(e: React.ChangeEvent<HTMLInputElement>) => {
          e.stopPropagation();
          setIsOrdersAmountFieldOpened(true);
        }}
        value={fieldValue.toString()}
      />
      <StyledDropdownIconJoint
        onClick={() => setIsOrdersAmountFieldOpened(true)}
      />

      {isOrdersAmountFieldOpened && (
        <>
          {isMobile ? (
            <OrdersAmountMobile
              setIsOrdersAmountFieldOpened={setIsOrdersAmountFieldOpened}
              isOrdersAmountFieldOpened={isOrdersAmountFieldOpened}
              setFieldValue={setFieldValue}
              fieldValue={fieldValue}
              labelText={labelText}
            />
          ) : (
            <OrdersAmountDesktop
              handleOrderNumberClicked={handleOrderNumberClicked}
              fieldValue={fieldValue}
            />
          )}
        </>
      )}
      {isOrdersAmountFieldOpened && !isMobile && <StyledFadeRectangle />}
    </StyledFormContainer>
  );
};

const StyledFormContainer = styled.div`
  display: flex;
  width: 143px;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  gap: 4px;
`;

const StyledLabel = styled.span`
  padding: 0px 2px;
  font-size: 12px;
  color: #4d4d4d;
`;

const StyledInput = styled(Input)`
  border-color: #c2c5cc;
  padding: 8px;
  display: flex;
  height: 40px;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  align-self: stretch;
  width: 100%;
  font-weight: 700;
`;

const StyledFadeRectangle = styled.div`
  width: 143px;
  height: 40px;
  position: absolute;
  bottom: -164px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
  z-index: 200;
  cursor: pointer;
  pointer-events: none;
`;

const StyledDropdownIconJoint = styled(DropdownIconJoint)`
  position: absolute;
  width: 24px;
  height: 24px;
  bottom: 8px;
  right: 8px;
  cursor: pointer;
`;

export default OrdersAmountForm;
